import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { contactAPI } from '../lib/api';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Textarea } from '../components/ui/textarea';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../components/ui/card';
import { Trophy, ArrowLeft, Send } from 'lucide-react';
import { toast } from 'sonner';
import { Link } from 'react-router-dom';

export default function ContactPage() {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  useEffect(() => { document.title = "Contact Us — Pools FC"; }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await contactAPI.submit(form);
      toast.success('Message sent!');
      setSent(true);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Failed to send');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <header className="border-b bg-card">
        <div className="max-w-[1200px] mx-auto px-4 sm:px-6 flex h-[64px] sm:h-[120px] items-center justify-between">
          <Link to="/" className="flex items-center gap-2 font-heading font-bold text-lg">
            <img src="/poolsfc-logo.png" alt="Pools FC" className="h-[48px] w-[48px] sm:h-[104px] sm:w-[104px] rounded-lg" />
            Pools FC
          </Link>
          <Button variant="ghost" size="sm" asChild><Link to="/"><ArrowLeft className="h-4 w-4 mr-1" />Back</Link></Button>
        </div>
      </header>
      <div className="max-w-lg mx-auto px-4 py-16">
        <Card>
          <CardHeader className="text-center">
            <CardTitle className="font-heading text-2xl">Contact Us</CardTitle>
            <CardDescription>Questions? Feedback? We'd love to hear from you.</CardDescription>
          </CardHeader>
          <CardContent>
            {sent ? (
              <div className="text-center py-8">
                <div className="h-12 w-12 rounded-full bg-[#f3f0ff] mx-auto mb-4 flex items-center justify-center"><Send className="h-5 w-5 text-[#5b3cc4]" /></div>
                <h3 className="font-heading text-lg font-semibold mb-1">Message Sent</h3>
                <p className="text-sm text-muted-foreground">We'll get back to you at {form.email}</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-4">
                <div><Label>Name</Label><Input value={form.name} onChange={(e) => setForm({...form, name: e.target.value})} required /></div>
                <div><Label>Email</Label><Input type="email" value={form.email} onChange={(e) => setForm({...form, email: e.target.value})} required /></div>
                <div><Label>Message</Label><Textarea value={form.message} onChange={(e) => setForm({...form, message: e.target.value})} rows={5} required /></div>
                <Button type="submit" className="w-full" disabled={loading}>{loading ? 'Sending...' : 'Send Message'}</Button>
              </form>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
